import { useRef } from 'react';
import { AxisAndGrid } from '../AxisAndGrid/AxisAndGrid';
import { SelectBox } from '../SelectBox/SelectBox';
import { useGeneratedAxisChart } from './hooks/useGeneratedAxisChart';
import { GeneratedAxisTooltip } from './GeneratedAxisTooltip';
import { GeneratedAxisZoomControls } from './GeneratedAxisZoomControls';
import type { GeneratedAxisChartProps } from './GeneratedAxisChart.types';

/** Own preparation and interactions while AxisAndGrid remains a rendering component. */
export const GeneratedAxisChart = ({ tooltip, hover_ref, HTML = [], ...props }: GeneratedAxisChartProps): JSX.Element => {
  const local_ref = useRef<HTMLDivElement>(null);
  const tooltip_ref = hover_ref ?? local_ref;
  const settings = props.handleClick && props.checkIfSelected && props.checkIfFiltered ? {
    selected: props.selected, handleClick: props.handleClick,
    checkIfSelected: props.checkIfSelected, checkIfFiltered: props.checkIfFiltered,
  } : undefined;
  const { axes, ...interactions } = useGeneratedAxisChart(props, settings);
  const plot_data = props.checkIfFiltered ? props.data?.filter(row => props?.checkIfFiltered?.(row, 'path', props.selected, {
    data: props.data, grouping_key: props.grouping_key, selected: props.selected,
    checkIfSelected: props.checkIfSelected, checkIfFiltered: props.checkIfFiltered,
  }) !== true) : props.data;
  const renderers = props.zoom_x || props.zoom_y
    ? [...HTML.filter(Renderer => Renderer !== SelectBox && Renderer !== GeneratedAxisZoomControls), SelectBox,
      ...(props.zoom === false ? [] : [GeneratedAxisZoomControls])] : HTML;
  return (
    <>
      <AxisAndGrid
        {...props}
        axes={axes}
        data={plot_data}
        hover_ref={tooltip_ref}
        HTML={renderers}
        {...interactions}
      />
      {tooltip !== false && <GeneratedAxisTooltip tooltip_ref={tooltip_ref} axes={axes} data={plot_data} options={tooltip} generated_props={{ ...props, tooltip, axes, HTML: renderers, hover_ref: tooltip_ref, ...interactions }} />}
    </>
  );
};
